import classNames from 'classnames';
import React, { useState, useEffect, useCallback } from 'react';
import { s as styleInject } from '../../style-inject.es-e7b07dd7.js';
import AddColorIcon from '../../Icons/AddColorIcon.js';
import { DefaultColorPicker } from './DefaultColorPicker.js';
import './CustomColorPickerDialog.js';
import 'wix-rich-content-ui-components';

var css_248z = ".OMsNo,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}._9yGqn{font-family:var(--ricos-settings-text-font-family,Helvetica Neue,Helvetica,Arial);position:relative}[dir] ._9yGqn{margin:0}[dir] .E-dmz.bboro{transform:scale(.7)}[dir] .E-dmz.bboro:after{border-color:var(--ricos-settings-text-color,#000);transform:scale(1.45)}.o2yB6{color:var(--ricos-fallback-color,#000);font-size:16px}[dir=ltr] .o2yB6{padding:10px 0 7px 20px}[dir=rtl] .o2yB6{padding:10px 20px 7px 0}.KTRmm{height:1px;width:auto}[dir] .KTRmm{background:var(--ricos-settings-dividers-color,rgba(51,51,51,.1));border:none;margin:11px 0 8px}[dir] ._8eviw .KTRmm{margin:0}.E-dmz{-webkit-flex:none;flex:none;height:20px;justify-self:center;outline:0;position:relative;width:20px}[dir] .E-dmz{cursor:pointer;margin-top:12px;padding:0}._8eviw .E-dmz{align-self:center;height:34px;justify-self:center;width:34px}[dir] ._8eviw .E-dmz{margin:0}[dir] .E-dmz{border:1px solid #ccc;border-radius:var(--ricos-settings-small-buttons-border-radius,50%)}.E-dmz:after{bottom:1px;box-sizing:border-box;content:\" \";display:block;height:20px;outline:0;position:relative;width:20px}[dir] .E-dmz:after{background:transparent;border:1px solid transparent;border-radius:var(--ricos-settings-color-palette-selected-button-border-radius,50%)}[dir=ltr] .E-dmz:after{right:1px}[dir=rtl] .E-dmz:after{left:1px}._8eviw .E-dmz:after{bottom:1px;height:34px;width:34px}[dir=ltr] .E-dmz.XjyCe{background:linear-gradient(to top left,#fff calc(50% - .8px),red 50%,#fff calc(50% + .8px),#fff)}[dir=rtl] .E-dmz.XjyCe{background:linear-gradient(to top right,#fff calc(50% - .8px),red 50%,#fff calc(50% + .8px),#fff)}.E-dmz:active,.E-dmz:focus,.E-dmz:hover{outline:0}.E-dmz:hover{opacity:.5}[dir] .E-dmz:not(.bboro):focus:after{border-color:#ccc}.dEirN{width:auto}._8eviw .dEirN{height:100%}[dir] ._8eviw .dEirN{margin:0 auto}.vSsWT{fill:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff))}[dir] .vSsWT{background-color:transparent;border:none;cursor:pointer;padding:0}.vSsWT svg{fill:var(--ricos-settings-action-color,var(--ricos-action-color,#116dff))}.vSsWT svg:hover{opacity:.5}._8eviw .vSsWT{align-self:center;justify-self:center}._8eviw .vSsWT svg{height:34px;vertical-align:bottom;width:34px}[dir] ._8eviw .vSsWT svg{transform:none}.kwEZy{display:grid;gap:8px;grid-template-columns:repeat(6,auto);width:180px}[dir] .kwEZy{margin:0 12px 9px}._8eviw .kwEZy{grid-row-gap:24px;width:auto}[dir] ._8eviw .kwEZy{margin:0;padding:24px 20px 22px}.ZKwfy{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff));font-size:14px;font-stretch:normal;font-style:normal;font-weight:300;height:18px;letter-spacing:normal;line-height:1.5;position:relative;text-decoration:underline}[dir] .ZKwfy{background-color:transparent;border:none;cursor:pointer}._8eviw .ZKwfy{font-size:16px}.ZKwfy:hover{opacity:.5}.mkL15{display:flex;justify-content:space-between}[dir] .mkL15{margin:10px 10px 0}._8eviw .mkL15{justify-content:center}[dir] ._8eviw .mkL15{margin:8px 0}";
var styles = {"fontElementMap":"OMsNo","colorPicker":"_9yGqn","colorPicker_button":"E-dmz","colorPicker_button_selected":"bboro","colorPicker_header":"o2yB6","colorPicker_separator":"KTRmm","mobile":"_8eviw","colorPicker_button_transparent":"XjyCe","colorPicker_palette":"dEirN","addColorButton":"vSsWT","colorPicker_buttons_container":"kwEZy","resetColorButton":"ZKwfy","colorPicker_bottom_container":"mkL15"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const lengthenHexColor = (color) => {
  const isShortenedHex = color.length === 4;
  if (!isShortenedHex) {
    return color;
  }
  return color.slice(1).split("").map((char) => char + char).join("").padStart(7, "#");
};
const ColorPicker = ({
  selectedColor,
  onChange,
  onResetColor,
  palette,
  schemeAttributes,
  schemeColor,
  userColors,
  t,
  onColorAdded,
  onCustomPickerToggle = (props) => /* @__PURE__ */ React.createElement(DefaultColorPicker, __spreadValues({}, props)),
  onCustomColorPicked = () => {
  },
  isMobile,
  children,
  dataHook
}) => {
  const [isCustomColorPickerOpened, setIsCustomColorPickerOpened] = useState(false);
  const id = `cpk_${Math.floor(Math.random() * 9999)}`;
  useEffect(() => {
    import('./CustomColorPicker.js');
  }, []);
  const closeCustomColorPicker = useCallback(() => {
    setIsCustomColorPickerOpened(false);
  }, []);
  const openCustomColorPicker = useCallback(() => {
    setIsCustomColorPickerOpened(true);
  }, []);
  const handleHexColorSave = (color) => {
    var _a, _b;
    const lengthenedColor = lengthenHexColor(color);
    const colorUpperCased = color.toUpperCase();
    const lengthenedUpperCasedColor = lengthenedColor.toUpperCase();
    const upperCasePalette = (_a = palette == null ? void 0 : palette.map((paletteColor) => paletteColor.toUpperCase())) != null ? _a : [];
    const upperCaseUserColors = (_b = userColors == null ? void 0 : userColors.map((userColor) => userColor.toUpperCase())) != null ? _b : [];
    const equalsColor = (itemColor) => itemColor === lengthenedUpperCasedColor || itemColor === colorUpperCased;
    const doesItemExistInPalette = upperCasePalette.filter(equalsColor).length > 0;
    const doesItemExistInUserItems = (upperCaseUserColors == null ? void 0 : upperCaseUserColors.filter(equalsColor).length) > 0;
    if (!doesItemExistInPalette && !doesItemExistInUserItems) {
      onColorAdded({ color: lengthenedColor });
    }
    onChange({ color: lengthenedColor });
  };
  const handleItemSave = (item) => {
    const doesItemExistInPalette = palette == null ? void 0 : palette.includes(item);
    const doesItemExistInUserItems = userColors == null ? void 0 : userColors.includes(item);
    if (!doesItemExistInPalette && !doesItemExistInUserItems) {
      onColorAdded({ color: item });
    }
    onChange({ color: item });
  };
  const onCustomColorSave = (color) => {
    if (color.startsWith("#") && (color.length === 7 || color.length === 4)) {
      handleHexColorSave(color);
    } else {
      handleItemSave(color);
    }
    closeCustomColorPicker();
  };
  const handleColorButtonClick = (color, e) => {
    const newColor = e.currentTarget.dataset.schemeColor || color;
    onChange == null ? void 0 : onChange({ color: newColor, event: e });
  };
  const handleResetColor = (e) => {
    onResetColor == null ? void 0 : onResetColor({ event: e });
  };
  const renderColorButtons = (colors, attributes) => colors.map((color, index) => {
    var _a;
    const selectedColorConverted = ((_a = selectedColor == null ? void 0 : selectedColor.startsWith) == null ? void 0 : _a.call(selectedColor, "#")) ? selectedColor.toUpperCase() : selectedColor;
    const colorConverted = color.startsWith("#") ? color.toUpperCase() : color;
    const isSelected = !!colorConverted && selectedColorConverted === colorConverted || !!schemeColor && selectedColor === schemeColor;
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        "data-hook": `modal-option${isSelected ? " selected" : ""}`,
        "data-scheme-color": attributes ? attributes[index] : "",
        title: color,
        key: `${color}_${index}`,
        className: classNames({
          [styles.colorPicker_button]: true,
          [styles.colorPicker_button_selected]: isSelected,
          [styles.colorPicker_button_transparent]: color === "transparent"
        }),
        style: color !== "transparent" ? { background: color } : {},
        onClick: (e) => handleColorButtonClick(color, e),
        type: "button"
      }
    );
  });
  const renderAddColorButton = () => /* @__PURE__ */ React.createElement(
    "button",
    {
      id: `add_color_button_${id}`,
      className: styles.addColorButton,
      onClick: openCustomColorPicker,
      "data-hook": "addColor",
      type: "button"
    },
    /* @__PURE__ */ React.createElement(AddColorIcon, null)
  );
  const renderResetColorButton = () => /* @__PURE__ */ React.createElement(
    "button",
    {
      id: `reset_color_button_${id}`,
      className: styles.resetColorButton,
      onClick: handleResetColor,
      "data-hook": "resetColor",
      type: "button"
    },
    t("ColorPicker_SetToDefault_ButtonLabel")
  );
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames(styles.colorPicker, { [styles.mobile]: isMobile }),
      tabIndex: 0,
      "data-hook": `color-picker ${dataHook || ""}`
    },
    isCustomColorPickerOpened ? onCustomPickerToggle({
      initialColor: selectedColor,
      onCustomColorChange: onCustomColorPicked,
      onCustomColorCancel: closeCustomColorPicker,
      onCustomColorSave,
      t,
      isMobile
    }) : children({
      renderPalette: () => renderColorButtons(palette, schemeAttributes),
      renderUserColors: () => renderColorButtons(userColors || []),
      renderAddColorButton,
      renderResetColorButton,
      mergedStyles: styles
    })
  );
};

export { ColorPicker as default };
//# sourceMappingURL=ColorPicker.js.map
